// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__XgF0p","productName":"Table_productName__3hEkn"};